"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicLoadManualStaticManager = void 0;
const dynamicLoadManager_1 = require("../../../dynamicLoad/dynamicLoadManager");
class DynamicLoadManualStaticManager extends dynamicLoadManager_1.DynamicLoadManagerBase {
}
exports.DynamicLoadManualStaticManager = DynamicLoadManualStaticManager;
//# sourceMappingURL=managerStatic.js.map